const React = require('react');
const { DateTimePicker } = require('@mui/x-date-pickers/DateTimePicker');
const { LocalizationProvider } = require('@mui/x-date-pickers/LocalizationProvider');
const { AdapterDayjs } = require('@mui/x-date-pickers/AdapterDayjs');
const Dayjs = require('dayjs');

const internals = {};

internals.toPickerValue = (value) => {

    if (!value) {
        return null;
    }

    if (Dayjs.isDayjs(value)) {
        return value.isValid() ? value : null;
    }

    const parsed = Dayjs(value);

    return parsed.isValid() ? parsed : null;
};

module.exports = function ControlledDateTimeField(props) {

    const {
        id,
        label,
        value,
        onBlur,
        onChange,
        onFocus,
        pickerProps = {},
        textFieldProps = {}
    } = props;

    return <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
            label={label}
            value={internals.toPickerValue(value)}
            onChange={(nextValue) => {

                if (typeof onChange === 'function') {
                    onChange(nextValue);
                }
            }}
            slotProps={{
                textField: {
                    id,
                    onBlur,
                    onFocus,
                    fullWidth: true,
                    ...textFieldProps,
                    InputLabelProps: textFieldProps.InputLabelProps || {}
                },
                ...pickerProps.slotProps
            }}
            {...pickerProps}
        />
    </LocalizationProvider>;
};

module.exports.internals = internals;
